import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { Browser } from './Browser';

export type BrowserContainerProps = {};

export function BrowserContainer(_props: BrowserContainerProps) {
  const dispatch = useDispatch();
  const allGenerators = useSelector(selectors.gallery.$generators);
  const isLoading = useSelector(selectors.raw.$rawAppState).isLoading;
  const appState = useSelector(selectors.raw.$rawAppState);
  const settings = useSelector(selectors.raw.$rawSettings);
  const { whiteThumbnails } = settings;
  const { isAiRunning } = appState;

  const callbacks = useMemo(
    () => ({
      onAction: (action: Action) => {
        dispatch(action);
      },
      onThumbChange: (value: string) => {
        const whiteThumbnails = value === 'white';
        dispatch(actions.settings.patch({ whiteThumbnails }));
      },
    }),
    []
  );

  if (isAiRunning) {
    return null;
  }

  return (
    <Browser
      generators={allGenerators}
      whiteThumbnails={whiteThumbnails}
      isLoading={isLoading}
      callbacks={callbacks}
    />
  );
}

export default BrowserContainer;
